import { makeStyles } from '@material-ui/core/styles';
import bg from "../assets/images/bg_small.jpg"
import bgDarkPurple from "../assets/images/bg_small_purple.png"

export const useStyles = makeStyles(theme => ({
  takisDivider: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "absolute",
    left: 0,
    right: 0,
    justifyContent: 'flex-end',
    bottom: 0,
    zIndex: 0,
    pointerEvents: "none"
  },
  takisDividerImage: {
    fill: theme.palette.yellow,
    marginBottom: "-0.1rem",
    width: "100%"
  },
  takisDividerMargin: {
    backgroundColor: theme.palette.yellow,
    width: "100%",
    marginBottom: "-0.3rem",
  },
  svgTranslation: {
    "& svg": {
      transform: "translateY(1.23rem)",
      [theme.breakpoints.up(theme.breakpoints.values.md)]:{
        transform: "translateY(1rem)",
      },
      [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
        transform: "translateY(0.73rem)",
      }
    }
  },
  transparent:{
    backgroundColor: 'transparent'
  },
  white: {
    backgroundColor: theme.palette.white
  },
  yellow: {
    backgroundColor: theme.palette.yellow
  },
  purple: {
    backgroundColor: theme.palette.purple
  },
  darkPurple: {
    backgroundColor: theme.palette.darkPurple
  },
  texturePurple: {
    backgroundImage:  `url(${bgDarkPurple})`,
    backgroundBlendMode: 'initial',
    [theme.breakpoints.up(theme.breakpoints.values.lg)]:{
        backgroundImage:  `url(${bg}), linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%)`,
        backgroundBlendMode: 'soft-light',
    },
    [`${theme.breakpoints.between(theme.breakpoints.values.md, theme.breakpoints.values.xl)} and (orientation: landscape)`]:{
        backgroundImage:  `url(${bgDarkPurple})`,
        backgroundBlendMode: 'initial',
    },
  },
  gridPurple: {
    backgroundImage: `linear-gradient(to top, ${theme.palette.gridPurple} 0%, ${theme.palette.gridPurple} 100%), url(${bg})`,
    backgroundBlendMode: 'multiply',
  }

}));
